const VIN_REGEX = /\b[A-HJ-NPR-Z0-9]{17}\b/gi;
const EMAIL_REGEX = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const PHONE_REGEX = /(?<!\d)(?:\+?\d[\d\s().-]{7,}\d)(?!\d)/g;
const PLATE_KEY_REGEX =
  /(license|licence|registration).*plate|plate.*(number|text)|registrationNumber/i;

function isPlateLike(value: string): boolean {
  const parts = value
    .trim()
    .toUpperCase()
    .split(/[-\s]+/);
  const normalizedLength = parts.join('').length;

  return (
    parts.length >= 2 &&
    normalizedLength >= 4 &&
    parts.every((part) => /^[A-Z0-9]{1,4}$/.test(part))
  );
}

function redactValue<T>(payload: T, key?: string): T {
  if (typeof payload === 'string') {
    const redacted = payload
      .replace(VIN_REGEX, '[REDACTED_VIN]')
      .replace(EMAIL_REGEX, '[REDACTED_EMAIL]')
      .replace(PHONE_REGEX, '[REDACTED_PHONE]');

    return (
      key && PLATE_KEY_REGEX.test(key)
        ? isPlateLike(redacted)
          ? '[REDACTED_PLATE]'
          : redacted
        : redacted
    ) as T;
  }

  if (Array.isArray(payload)) {
    return payload.map((item) => redactValue(item, key)) as T;
  }

  if (payload && typeof payload === 'object') {
    return Object.fromEntries(
      Object.entries(payload).map(([entryKey, value]) => [entryKey, redactValue(value, entryKey)])
    ) as T;
  }

  return payload;
}

export function redactForLlm<T>(payload: T): T {
  return redactValue(payload);
}
